'use strict';

import mediator from '../../js/mediator';
import config from '../../js/config';
import SecondaryNavigation from '../SecondaryNavigation/SecondaryNavigation';

var FamilyPagesNavigationTabsView = SecondaryNavigation.extend({

  events: {
    'click .SecondaryNavigation-tab': 'render'
  },
  initialize: function() {
    SecondaryNavigation.prototype.initialize.apply(this);
    this.$overviewPage = this.$el.find('.FamilyPagesNavigationTabs-overview');
    this.$categoryPage = this.$el.find('.FamilyPagesNavigationTabs-category');
  },

  render: function(e) {
    this.renderTabContent(e);
    mediator.trigger(config.events.masonry.resize, {});
  }

});

export function create($parent) {
  $parent.find('.FamilyPagesNavigationTabs').each((n, el) => new FamilyPagesNavigationTabsView({ el }))
}



// WEBPACK FOOTER //
// ./assets/components/FamilyPagesNavigationTabs/FamilyPagesNavigationTabsView.js